'use strict';

angular.module('ahlulhadith').controller('RecommendationsController', ['$rootScope', 'app', function($rootScope, app) {
  $rootScope.title.text = app == 'ta' ? 'உலமாக்களின் பரிந்துரைகள்' : 'Recommendations';
  $rootScope.title.hideHeader = false;
}]);